import BlocklistError from "@/components/Error/BlocklistError";
import CustomError from "@/components/Error/CustomError";
import GeneralError from "@/components/Error/GeneralError";
import JointExpired from "@/components/Error/JointExpired";
import JointNotEligible from "@/components/Error/JointNotEligible";
import MissingEmailError from "@/components/Error/MissingEmailError";
import NotFound from "@/components/Error/NotFound";
import ServicesError from "@/components/Error/ServicesError";
import { setClickInsightServiceError } from "@/lib/util";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import InvalidSSOError from "@/components/Error/InvalidSSOError";

enum ErrorType {
  General = 1,
  Blocklist,
  Services,
  InvalidSSO,
  JointExpired,
  JointNotEligible,
  CustomError,
  NotFound,
  MissingEmail
}

export default function Error() {
  const { errId } = useParams();

  useEffect(() =>{
    setClickInsightServiceError();
  });


  if (errId) {
    switch (+errId) {
      case ErrorType.General:
        return <GeneralError />;
      case ErrorType.Blocklist:
        return <BlocklistError />;
      case ErrorType.InvalidSSO:
        return <InvalidSSOError />;
      case ErrorType.JointExpired:
        return <JointExpired />;
      case ErrorType.JointNotEligible:
        return <JointNotEligible />
      case ErrorType.CustomError:
        return <CustomError />
      case ErrorType.NotFound:
        return <NotFound />
      case ErrorType.MissingEmail:
        return <MissingEmailError />
      default:
        return <ServicesError />;
    }
  } else {
    return <ServicesError />;
  }
}
